// EXPORT

export const appInfo = {
	debug: DEBUG_MODE,
	env: ENV,
	version: VERSION
};

export const copdateApi = {
	url: API_PROXY_URL
};

export default {
	appInfo,
	copdateApi
};
